// JavaScript equivalent of Python TextChoices enums
export const GalleryType = {
  ROOT: { value: "root", label: 'Root' },
  PUBLIC: { value: "public", label: 'Public' },
  PRIVATE: { value: "private", label: 'Private' },
  PICA_CODE: { value: "pica_code", label: 'Pica Code' },
  
  // Helper methods
  fromValue(value) {
    return Object.values(this).find(type => 
      typeof type === 'object' && type.value === value
    );
  },
  
  values() {
    return Object.values(this)
      .filter(item => typeof item === 'object')
      .map(item => item.value);
  },
  
  choices() {
    return Object.values(this)
      .filter(item => typeof item === 'object')
      .map(item => [item.value, item.label]);
  }
};

export default GalleryType;